import { render, staticRenderFns } from "./CardAsessment.vue?vue&type=template&id=58922d70&"
import script from "./CardAsessment.vue?vue&type=script&lang=js&"
export * from "./CardAsessment.vue?vue&type=script&lang=js&"
import style0 from "./CardAsessment.vue?vue&type=style&index=0&id=58922d70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports